import WorkFlowComponent from "../components/WorkFlow";
function WorkFlow() {
    // const hookWorkFlow = useWorkFlow()
    return <WorkFlowComponent {...[]} />;
}

export default WorkFlow;
